import getLangKey from './getLangKey';
export const PRIVACY_POLICY_LINKS = {
  en: 'https://legal.hubspot.com/privacy-policy',
  ja: 'https://legal.hubspot.com/jp/privacy-policy',
  de: 'https://legal.hubspot.com/de/privacy-policy',
  es: 'https://legal.hubspot.com/es/privacy-policy',
  pt: 'https://legal.hubspot.com/br/privacy-policy',
  fr: 'https://legal.hubspot.com/fr/privacy-policy'
};
const getPrivacyPolicyLink = () => {
  const lang = getLangKey();
  return PRIVACY_POLICY_LINKS[lang || ''] || PRIVACY_POLICY_LINKS.en;
};
export default getPrivacyPolicyLink;